module.exports = __webpack_public_path__ + "static/media/38.be311f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/38.jpg
// module id = 298
// module chunks = 0